import type { EmptyObject } from '@change-corgi/core/types';

import { SectionSeparator } from 'src/app/pages/petitionDetails/shared/components';
import { SECTION_ID_MAPPING } from 'src/app/pages/petitionDetails/shared/constants';

import { useScrollToSection } from '../../hooks/useScrollToSection';

import { SignaturesDistributionContainerSunrise } from './components/SignaturesDistributionContainerSunrise';
import { SupporterVoices as SupporterVoicesSunrise } from './components/SupporterVoicesSunrise';
import { useSupporterVoicesSection } from './components/SupporterVoicesSunrise/hooks/useSupporterVoicesSection';
import { TheSupportersTitle } from './components/TheSupportersTitle';
import { TheSupportersContextProvider, useTheSupportersContext } from './shared/context';

const TheSupportersInner: React.FC<EmptyObject> = () => {
	const {
		data: { showSupporterVoicesSection },
	} = useSupporterVoicesSection();

	const {
		data: { hasMap },
	} = useTheSupportersContext();

	const {
		data: { refs },
	} = useScrollToSection();

	return (
		<div id={SECTION_ID_MAPPING.SUPPORTER_VOICES} ref={refs[SECTION_ID_MAPPING.SUPPORTER_VOICES]}>
			<SectionSeparator />
			<div className="mb-6 lg:mb-16">
				{showSupporterVoicesSection ? (
					<>
						<TheSupportersTitle />
						<SupporterVoicesSunrise />
					</>
				) : null}
				{hasMap ? <SignaturesDistributionContainerSunrise /> : null}
			</div>
		</div>
	);
};

export const TheSupportersSunrise: React.FC<EmptyObject> = () => {
	return (
		<TheSupportersContextProvider>
			<TheSupportersInner />
		</TheSupportersContextProvider>
	);
};
